import React from 'react'
import Group from "../assets/image/Group img.png"
import workout from "../assets/image/workout-with-personal-trainer-wearing-protection-masks 1.png"
import { Link, useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2';


function Stretch() {

  const session_url=localStorage.getItem("auth-token");
  const navigate = useNavigate();
  const handleGetStarted = ()=>{
    if(!session_url){
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: `Please Sign In First!`
      });
    }else{
      navigate('/booking');
    }
  }
    return (
        <>

            <div class="hero-container">
                <div class="massage_banner stretch_banner">
                    <div class="container pt-5 pb-5">
                        <div class="row pt-5 pb-5">
                            <div class="col-lg-5 col-md-12 col-sm-12">
                            </div>
                            <div class="col-lg-7 col-md-12 col-sm-12">
                                <div class="stretch_text">
                                    <h1>The Poetry of Motion <span> & </span> Your Way to Fluidity</h1>
                                    <div
                                        onClick={handleGetStarted}
                                    >
                                        <button class="custom_but"
                                        >Book An Appointment</button>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div class="hero-container">
                <div class="massage_banner_bg">
                    <div class="container">
                        <p class="massage_banner_text">Stretching isn't just an activity;
                            it's a philosophy. It's the thread that weaves together the
                            fabric of comfort, the bridge between stiffness and fluidity.
                            Our expert techniques help you regain lost flexibility, release
                            pent-up stress, and elevate your well-being</p>

                    </div>

                </div>
            </div>
            <div class="hero-container">
                <div class="row pt-5 pb-5 ms-0 me-0">
                    <div class="col-lg-6 col-md-12 col-sm-12">
                        <div class="stretch_type">
                            <img src={Group} alt="Group" />
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-12 col-sm-12">
                        <div class="stretch_timeline">
                            <section class="py-5">
                                <ul class="timeline-with-icons">
                                    <li class="timeline-item mb-5">
                                        <span class="timeline-icon">

                                        </span>

                                        <h5 class="fw-bold">FLEXIBILITY: INJURY PREVENTION</h5>
                                        <p class="fw-bold">
                                            Prevent injuries by improving flexibility and mobility
                                        </p>
                                    </li>

                                    <li class="timeline-item mb-5">

                                        <span class="timeline-icon">
                                        </span>
                                        <h5 class="fw-bold">IMPROVED CIRCULATION: POSTURE</h5>
                                        <p class="fw-bold">
                                            Enhance circulation and posture for better overall health
                                        </p>
                                    </li>

                                    <li class="timeline-item mb-5">

                                        <span class="timeline-icon">
                                        </span>
                                        <h5 class="fw-bold">STRESS RELIEF</h5>
                                        <p class="fw-bold">
                                            Reduce stress and promote relaxation through these practices
                                        </p>
                                    </li>

                                    <li class="timeline-item mb-5">

                                        <span class="timeline-icon">
                                        </span>
                                        <h5 class="fw-bold">RELAXATION</h5>
                                        <p class="fw-bold">
                                            Achieve a state of relaxation to alleviate tension and stress
                                        </p>
                                    </li>

                                    <li class="timeline-item mb-5">

                                        <span class="timeline-icon">
                                        </span>
                                        <h5 class="fw-bold">MUSCLE RECOVERY</h5>
                                        <p class="fw-bold">
                                            Support muscle recovery after workouts or physical activities
                                        </p>
                                    </li>
                                    <li class="timeline-item mb-5">

                                        <span class="timeline-icon">
                                        </span>
                                        <h5 class="fw-bold">BALANCE AND COORDINATION</h5>
                                        <p class="fw-bold">
                                            Enhance balance and coordination for better physical control
                                        </p>
                                    </li>
                                    <li class="timeline-item mb-5">

                                        <span class="timeline-icon">
                                        </span>
                                        <h5 class="fw-bold">JOINT HEALTH ENERGY FLOW</h5>
                                        <p class="fw-bold">
                                            Promote joint health and energy flow throughout the body
                                        </p>
                                    </li>
                                    <li class="timeline-item mb-5">

                                        <span class="timeline-icon">
                                        </span>
                                        <h5 class="fw-bold">BETTER PERFORMANCE</h5>
                                        <p class="fw-bold">
                                            Boost overall performance in physical and mental activities
                                        </p>
                                    </li>
                                    <li class="timeline-item mb-5">

                                        <span class="timeline-icon">
                                        </span>
                                        <h5 class="fw-bold">MIND-BODY CONNECTION</h5>
                                        <p class="fw-bold">
                                            Cultivate a stronger connection between the mind and body
                                        </p>
                                    </li>
                                    <li class="timeline-item mb-5">

                                        <span class="timeline-icon">
                                        </span>
                                        <h5 class="fw-bold">QUALITY SLEEP</h5>
                                        <p class="fw-bold">
                                            Improve sleep quality and overall restfulness
                                        </p>
                                    </li>
                                    <li class="timeline-item mb-5">

                                        <span class="timeline-icon">
                                        </span>
                                        <h5 class="fw-bold">PAIN MANAGEMENT</h5>
                                        <p class="fw-bold">
                                            Manage and alleviate pain through these practices
                                        </p>
                                    </li>
                                    <li class="timeline-item mb-5">

                                        <span class="timeline-icon">
                                        </span>
                                        <h5 class="fw-bold">FUNCTIONAL MOVEMENT</h5>
                                        <p class="fw-bold">
                                            Enhance functional movement for everyday activities
                                        </p>
                                    </li>


                                </ul>
                            </section>
                        </div>

                    </div>
                </div>
            </div>
            <div class="container ">
                <div class="trans_form trans_form1" >
                    <h1>Your Stretching Journey Starts Here</h1>
                    <p>Whether you're an athlete seeking peak performance,
                        someone combating desk-related stiffness, or simply
                        on a quest for well-being, our tailored stretching
                        routines cater to your unique needs. Join us on this
                        transformative journey where each stretch is a step
                        toward a more fluid, balanced, and liberated you</p>


                </div>

            </div>
            <div class="hero-container">
                <div class="massage_banner stretchinf_bn">
                </div>
            </div>
            <div class="hero-container">
                <div class="massage_banner_bg  bg_col">
                    <div class="container">
                        <h1 class="stretchinf_bn_text">Who are the professionals providing
                            Zorova Stretch?</h1>
                    </div>

                </div>
            </div>
            <div class="hero-container">
                <div class="row  ms-0 me-0">
                    <div class="col-lg-6 col-md-6 col-sm-12 p-0">
                        <div class="stretch_type_text">
                            <p>
                                At Zorova Stretch, your well-being is our top priority. Our team of professionals is handpicked for their expertise, commitment, and dedication to your journey of enhanced flexibility and vitality.
                                Our personal trainers, the core of our team, hold certifications from accredited programs, ensuring a high standard of knowledge and skill. You can trust that you're in capable hands, guided by professionals who understand the art and science of effective stretching
                            </p>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 p-0">
                        <div class="stretch_type1">
                            <img src={workout} alt="workout" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="container-fluid ps-0 pe-0">
                <div class="review_div">
                    <h1>Revive Your Spark</h1>
                    <div
                        onClick={handleGetStarted}
                    >
                        <button class="custom_but"
                        >Book An Appointment</button>
                    </div>
                </div>
            </div>

        </>
    )
}

export default Stretch
